import {testUsers} from "@hosttools/core/constant";
import {UserContext} from "@hosttools/frontend";
import {useContext} from "react";

import useSearchQuery from "@/admin/hooks/useSearchQuery";

type Params = {
    returnUrl?: string;
    state?: string;
    isPublicPage?: boolean;
};

export function useAirbnbOAuthUrl({returnUrl, state, isPublicPage}: Params) {
    const {user} = useContext(UserContext);
    const searchQuery = useSearchQuery();

    const isTestUser = isPublicPage
        ? searchQuery.get("test") === "1"
        : testUsers.includes(user.username);

    const clientID = isTestUser ? AIRBNB_TEST_CLIENT_ID : AIRBNB_CLIENT_ID;
    return `https://www.airbnb.com/oauth2/auth?client_id=${clientID}&redirect_uri=${encodeURIComponent(
        returnUrl ?? AIRBNB_REDIRECT_URL
    )}&scope=${AIRBNB_SCOPE}&state=${state ? encodeURIComponent(state) : ""}`;
}
